import Icon from "./Icon";

export default class Message extends Icon {
  constructor() {
    super();
    this.d = `M 366 48.45 H 102 C 28.7 47.5 0 74.765 0 108.3 V 324.9 C 2 369.55 2 406.6 94 404.7 H 211 V 523.45 C 268 494 301 454.1 332 401.85 H 448 C 484 399.95 510 399 513 338.2 V 109.25 C 512 75.715 483.3 48.45 426 48.45 Z Z`;
  }
}
